import { render, staticRenderFns } from "./VentLabel.vue?vue&type=template&id=28858d41&"
import script from "./VentLabel.vue?vue&type=script&lang=ts&"
export * from "./VentLabel.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports